import DocumentPickerV1 from "../../../../components/form_builder/elements/document_picker/DocumentPickerV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-form-dropdown-v1",
  component: DocumentPickerV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      description: "",
      value: "",
      required: false,
      hidden: false,
      formId: "",
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) =>
      value && value.values
        ? Object.keys(value.values)
            .map(field => `${field}: ${value.values[field]}`)
            .join("\n")
        : ""
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
